import { errorServiceInstance } from "./error.service";
var CssService = /** @class */ (function () {
    function CssService() {
        this.listeners = [];
        this.theClass = "loading";
        this.isBox = false;
    }
    CssService.prototype.addListener = function (func) {
        // this if is probably no longer necessary when we convert to typescript
        if (typeof func === "function") {
            this.listeners.push(func);
        }
    };
    CssService.prototype.callListeners = function () {
        var _this = this;
        this.listeners.forEach(function (listener) {
            try {
                listener(_this.theClass, _this.isBox);
            }
            catch (e) {
                errorServiceInstance.criticalError(e);
            }
        });
    };
    CssService.prototype.setClass = function (_theClass, _isBox) {
        this.theClass = _theClass;
        this.isBox = _isBox || false;
        this.callListeners();
    };
    CssService.prototype.getClass = function () {
        // return loading if class is empty
        return this.theClass || "loading";
    };
    return CssService;
}());
export default new CssService();



//////////////////
// WEBPACK FOOTER
// ./js/services/css.service.ts
// module id = AviY
// module chunks = 1